import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import AboutPopup from './AboutPopup';

import plus from '../assets/img/plus.png';
import minus from '../assets/img/minus.png';
import cross from '../assets/img/cross.png';

import tutoBoy from "../assets/img/tutoBoy.png";
import emailToken from "../assets/img/emailToken.png";
import coffee from "../assets/img/coffee.png";
import warningOrange from "../assets/img/warningOrange.png";

class RightSide extends Component {
    constructor(props) {
        super(props)

        this.state = {
            closePopup: false,
            closePopupOne: false,
            displayAbout: false
        }
    }

    hidePopup = () => {
        this.setState({ closePopupOne: true });
        // document.getElementsByClassName("col-xl-3")[0].style.display = "none"
    }

    displayAboutPopup = () => {
        this.setState({ displayAbout: true, closePopup: !this.state.closePopup });
    }

    hideAbout = () => {
        this.setState({ displayAbout: false, closePopup: !this.state.closePopup });
    }

    render() {
        const { t } = this.props;
        const classPopup = this.state.closePopup || this.state.closePopupOne ? ["col-xl-3 col-lg-12 closeHelper"] : [" helper helperDepot"];
        return (
            <div>
                <div>
                    <div className="more">
                        <span className="grey_pill" onClick={e => this.state.displayAbout === false ? this.displayAboutPopup() : this.hideAbout()}>{this.state.displayAbout ? <span className="aboutBtn"> {t("general.hideAbout")} <img src={minus} alt="" /> </span> : <span className="aboutBtn"> {t("general.about")} <img src={plus} alt="" /> </span>}</span>
                    </div>
                    {this.state.displayAbout ? <AboutPopup selectedQuestion="noToken" displayAbout={this.state.displayAbout} /> : null}
                </div>
                {this.props.depositAvailable
                    ?
                    <div className={classPopup}>
                        <div className="Card CardWithTimes">
                            <span className="closeCard"><img src={cross} alt="" onClick={e => this.hidePopup()} /></span>
                            <img src={tutoBoy} className="tutoBoy" alt="" />
                            <div className="tutoList">
                                <span>
                                    <img src={warningOrange} alt="" />
                                    <span>{t("rightSide.importantInfo")}</span>
                                </span>
                                <span>
                                    <img src={emailToken} alt="" />
                                    <span>{t("rightSide.desc")}</span>
                                </span>
                                <span>
                                    <img src={coffee} alt="" />
                                    <span>{t("general.coffeeTutoMsg")}</span>
                                </span>

                            </div>
                            <span>{t("rightSide.desc2")}</span>
                        </div>
                    </div>
                    :
                    null}
            </div>

        )
    }
}

export default withTranslation()(RightSide);
